import React, { useState, useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Typography, Grid, CircularProgress } from '@material-ui/core'
import axios from 'axios';
import StrikeReportDetails from './StrikeReportDetails';
import { handleAxiosError, getAPIUrl } from '../AppUtils';

const styles = theme => ({
});

function StrikeReportDetailsPage(props) {
    const { classes, match, logo, orgSettings } = props;
    const source = axios.CancelToken.source();

    const [reportDetails, setReportDetails] = useState(undefined);
    const [loadingReport, setLoadingReport] = useState(true);
    //mount, unmount
    useEffect(() => {
        getReportDetails();
        return () => {source.cancel("unmount");}
    }, []);

    function getReportDetails() {
        axios.get(getAPIUrl()+`/strikeReportDetails/${match.params.id}`,{cancelToken: source.token})
        .then(response => {
            setReportDetails(response.data);
            setLoadingReport(false);
        })
        .catch(error => {
            if(handleAxiosError(error)!=='cancel'){
                setLoadingReport(false);
            }
        });
    }
    if(loadingReport){
        return (
            <Grid container justify='center' alignItems='center'>
                <CircularProgress/>
            </Grid>
        )
    }
    return (
        reportDetails?
            <StrikeReportDetails
                report={reportDetails}
                orgSettings={orgSettings}
                logo={logo}
                history={props.history}
            />
            :<Grid container justify='center' alignItems='center'>
                <Typography className={classes.text} variant="h4">
                    Report Not Found
                </Typography>
            </Grid>
    );
}

export default withStyles(styles)(StrikeReportDetailsPage);